<template>
  <v-col>
    <v-row justify="center">
      <v-row class="ma-2">
        <v-col cols="12" md="6">
          <v-row class="mb-2">
            <v-icon class="black-color" @click="$emit('close')">
              mdi-arrow-left
            </v-icon>
            <h4 class="grey-color mx-4" style="font-weight: 500">
              Notification Info
            </h4>
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <v-row justify="center">
      <div class="white-card">
        <v-col v-show="notification" class="pa-8">
          <v-row justify="start">
            <h2 class="fs400 my-10">Notification Info</h2>
          </v-row>
          <v-row justify="start">
            <v-col cols="6" md="3">
              <v-row>
                <p>Date:</p>
              </v-row>
            </v-col>
            <v-col cols="6" md="3">
              <v-row>
                <p>{{ notification.date }}</p>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-8" justify="start">
            <v-col cols="6" md="3">
              <v-row>
                <p>Time:</p>
              </v-row>
            </v-col>
            <v-col cols="6" md="3">
              <v-row>
                <p>{{ notification.time }}</p>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-8" justify="start">
            <v-col cols="6" md="3">
              <v-row>
                <p>Type:</p>
              </v-row>
            </v-col>
            <v-col cols="6" md="3">
              <v-row>
                <p>{{ notification.type }}</p>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-8" justify="start">
            <v-col cols="6" md="3">
              <v-row>
                <p>User Type:</p>
              </v-row>
            </v-col>
            <v-col cols="6" md="3">
              <v-row>
                <p>{{ notification.userType }}</p>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-8" justify="start">
            <v-col cols="6" md="3">
              <v-row>
                <p>Message:</p>
              </v-row>
            </v-col>
            <v-col cols="6" md="3">
              <v-row>
                <p>{{ notification.message }}</p>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </div>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    notification: {},
  },
};
</script>

<style></style>